import React from 'react';
import { Box, Slider } from '@mui/material';
import { actions as builderActions } from "@/store/builderSlice";
import { useDispatch } from 'react-redux';

export default function LightingTray() {
  const dispatch = useDispatch();
  const updateLightIntensity = (event: Event, newValue: number | number[]) => {
    dispatch(builderActions.updateLightIntensity({
      lightIntensity: newValue
    }));
  };
  return (
    <Box component={'div'} sx={{ width: 120 }}>
      <Slider
        aria-label="Small steps"
        defaultValue={0.3}
        step={0.05}
        marks
        min={0.1}
        max={1}
        valueLabelDisplay="auto"
        onChange={updateLightIntensity}
      />
    </Box>
  );
}